import { DispatchApplicationAction } from '../actions';
import { canPartyBeDeleted } from '../calculations/canPartyBeDeleted';
import { useMemo } from 'react';
import { useApplicationContext } from '../context';
import { useSelectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { ePartyPurpose } from '../../../ui-toolkit/enums/ePartyPurpose';
import { IParty } from '../../../ui-toolkit/orders/interfaces/IParty';
import { IOrderDetailsData } from '../../../ui-toolkit/orders/interfaces/IOrderDetailsData';

export interface IPartySelectorResult {
  isUser: boolean;
  isEditing: boolean;
  showPurpose: boolean;
  order: IOrderDetailsData;
  canDelete: boolean;
  canEdit: boolean;
}

const canBePersonOrEntity = [ePartyPurpose.borrower, ePartyPurpose.buyer, ePartyPurpose.seller];

export const usePartySelector = (party: IParty, isNew: boolean): [IPartySelectorResult, DispatchApplicationAction] => {
  const [state, dispatch] = useApplicationContext();
  const { data: orderData } = useSelectCurrentOrder();

  const partyState = useMemo(
    () => ({
      isUser: canBePersonOrEntity.indexOf(party.purpose) >= 0,
      isEditing: party === state.partyModals.editingParty || isNew,
      showPurpose: orderData.parties.indexOf(party) === orderData.parties.findIndex((t) => t.purpose === party.purpose),
      order: orderData,
      canDelete: party !== state.partyModals.addingParty && canPartyBeDeleted(orderData.parties, party),
      canEdit: !party.read_only,
    }),
    [party, state.partyModals, orderData, isNew]
  );

  return [partyState, dispatch];
};
